import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿TMS es mejor que la medicación para la depresión?",
    answer:
      "No hay una respuesta universal. La TMS convencional y SAINT® están autorizadas por la FDA para el trastorno depresivo mayor. SAINT® está indicada para adultos que no han mejorado con antidepresivos. La mejor opción depende del historial de cada persona y se evalúa en una consulta.",
  },
];

export const esTmsVsMedication = makeEsArticle({
  slug: "tms-vs-medication",
  title: "TMS frente a medicación para la depresión",
  description:
    "Comparación de la terapia TMS (incluida SAINT®) y los antidepresivos: cómo actúan, duración del efecto e indicaciones para el trastorno depresivo mayor.",
  h1: "TMS frente a medicación para la depresión",
  breadcrumbLabel: "TMS vs medicación",
  shortAnswer:
    "La medicación para la depresión actúa químicamente sobre el cerebro durante semanas o meses. La TMS es una estimulación magnética no invasiva autorizada por la FDA para el trastorno depresivo mayor. SAINT® es una TMS acelerada con orientación por fMRI, indicada para adultos que no han mejorado con antidepresivos. La TMS no reemplaza la medicación; el enfoque para cada persona se evalúa en una consulta con el equipo clínico.",
  keyTakeaways: [
    "La medicación actúa químicamente durante semanas o meses.",
    "La TMS es estimulación magnética no invasiva autorizada por la FDA.",
    "SAINT® es TMS acelerada con orientación por fMRI.",
    "SAINT® está indicada para adultos que no han mejorado con antidepresivos.",
    "El enfoque se evalúa en una consulta.",
  ],
  sections: [
    {
      heading: "Cómo actúa cada uno",
      paragraphs: [
        "Los antidepresivos actúan sobre la química del cerebro. La TMS utiliza campos magnéticos para estimar regiones específicas del cerebro relacionadas con el estado de ánimo. Ambas están autorizadas por la FDA para el trastorno depresivo mayor.",
      ],
    },
    {
      heading: "Para quién está indicada SAINT®",
      paragraphs: [
        "SAINT® es una TMS acelerada que administra 50 sesiones en cinco días con orientación individualizada por fMRI. Está autorizada por la FDA (510(k) K220177, septiembre de 2022) para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
        "No está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones. La elegibilidad se confirma mediante una evaluación psiquiátrica.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "Cole EJ, et al. Stanford Neuromodulation Therapy (SNT): A Double-Blind Randomized Controlled Trial. Am J Psychiatry. 2022;179(2):132-141.",
      url: "https://doi.org/10.1176/appi.ajp.2021.20101429",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
